const getFlatVariations = (commonCanopies, commonVariaton) => {

	return {
		'5935': {
			...commonVariaton,
			size: {
				width: 0.0907,
				height: 0.397,
				depth: 0.0907
			},
			paddingTop: -0.35,
			familyName: 'flat',
			related: ['0820'],
			canopy: {
				...commonCanopies,
				"10": {
					...commonCanopies['10'],
					source: '/models/canopy_skan.glb',
					size: {
						width: 0.16,
						depth: 0.16,
						height: 0.033
					},
				}
			},
			light: {
				type: 'spot',
				power: 199,
				options: { angle: Math.PI / 8 }
			}
		}
	}
}

export default getFlatVariations